const docViewOrigin = 'documentsReducer';
const FETCH_DOCUMENTS = `${docViewOrigin}/fetchDocuments`;
const FETCH_DOCUMENTS_SUCCESS = `${docViewOrigin}/fetchDocumentsSuccess`;
const FETCH_DOCUMENTS_FAILURE = `${docViewOrigin}/fetchDocumentsFailure`;

export { FETCH_DOCUMENTS, FETCH_DOCUMENTS_SUCCESS, FETCH_DOCUMENTS_FAILURE };
